import { render, staticRenderFns } from "./knowledgeBaseType.vue?vue&type=template&id=6b68eb74"
import script from "./knowledgeBaseType.vue?vue&type=script&lang=js"
export * from "./knowledgeBaseType.vue?vue&type=script&lang=js"
import style0 from "./knowledgeBaseType.vue?vue&type=style&index=0&id=6b68eb74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports